import React from 'react'
import { stringify } from 'query-string'

import AnnotationInboxList from '../../components/AnnotationInboxList'
import ArtboardSubscriptionStatus from '../../components/ArtboardSubscriptionStatus'
import CommentTabMessageRestricted from '../../components/CommentTabMessageRestricted'

import { Share } from '../../types'
import { useVersioning } from 'modules/versioning'
import { useQueryParams } from 'utils'

// This is a valid use case to narrow down Component type
// eslint-disable-next-line no-restricted-imports
import { NotificationSubscriptionStatus } from '@sketch/gql-types/expansive'

interface ArtboardAnnotationsProps {
  share: Share
  permanentPageIdentifier: string
  permanentArtboardIdentifier: string
  permanentArtboardShortId: string
  artboardNotificationStatus: NotificationSubscriptionStatus
  isViewingLatestVersion: boolean
}

const ArtboardAnnotations: React.FC<ArtboardAnnotationsProps> = props => {
  const {
    share,
    permanentArtboardIdentifier,
    permanentArtboardShortId,
    artboardNotificationStatus,
  } = props

  const { versionShortId } = useVersioning()

  const { annotation, ...otherParams } = useQueryParams<
    'ARTBOARD_DETAIL_UUID' | 'ARTBOARD_DETAIL'
  >()

  if (!share.commentsEnabled) {
    return <CommentTabMessageRestricted />
  }

  const artboardSubscriptionStatus = (
    <ArtboardSubscriptionStatus
      shareIdentifier={share.identifier}
      permanentArtboardIdentifier={permanentArtboardIdentifier}
      permanentArtboardShortId={permanentArtboardShortId}
      documentVersionShortId={versionShortId}
      notificationStatus={artboardNotificationStatus}
    />
  )

  return (
    <AnnotationInboxList
      shareIdentifier={share.identifier}
      permanentArtboardId={permanentArtboardIdentifier}
      resolveAnnotationLink={annotation => location => ({
        ...location,
        state: {
          isFromCommentTab: true,
        },
        search: stringify({
          ...otherParams,
          annotation: annotation.identifier,
        }),
      })}
      navbarAction={artboardSubscriptionStatus}
      activeAnnotationIdentifier={annotation}
    />
  )
}

export default ArtboardAnnotations
